<template>
  <VanPopup v-model:show="show" round position="bottom">
    <VanPicker
      :columns="columns"
      :title="title"
      @cancel="show = false"
      @confirm="onConfirm"
      :confirm-button-text="t('Buttons.momentSave')"
      :cancel-button-text="t('Buttons.cancel')"
    />
  </VanPopup>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { PickerConfirmEventParams } from "vant";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  showAll: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update:show", "confirm"]);

const show = computed({
  get: () => props.show,
  set: (value) => {
    emit("update:show", value);
  },
});

const store = useGalGameEditor();
const { t } = useI18n();

const columns = computed(() => {
  let list: { text: string; value: number }[] = [];
  const { name } = store.nodeMap[store.beginningNode]!;
  if (props.showAll)
    list.push({
      text: t(`Buttons.all`),
      value: 0,
    });
  list.push({
    text: `${t("game.beginning")}:${name}`,
    value: store.beginningNode,
  });

  store.plotList.forEach((value, idx) => {
    const { name } = store.nodeMap[value]!;
    list.push({ text: `${t("game.plotPoint")}${idx + 1}:${name}`, value });
  });

  store.endingList.forEach((value, idx) => {
    const { name } = store.nodeMap[value]!;
    list.push({ text: `${t("game.tab.endings")}${idx + 1}:${name}`, value });
  });

  return list;
});
const onConfirm = (value: PickerConfirmEventParams) => {
  const targetNodeId = value.selectedValues[0] as number;
  emit("confirm", targetNodeId);
};
</script>
